/**
* @Description 文件功能说明：车辆绑定记录 组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div class="table-item-box" style="padding: 10px;">
        <section style="height: 100%;">
            <!-- 表格 -->
            <el-table :data="record"
                      ref="multipleTable"
                      @sort-change="changeSort"
                      stripe
                      style="width: 100%;margin-bottom: 10px;height: calc(100% - 90px);"
                      :class="{'table': true, 'no-pagination': pagination.total <= pagination.limit}"
            >
                <el-table-column prop="car_type" label="车辆类型" min-width="120px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.carType">{{scope.row.carType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="car_number" label="车牌号" min-width="120px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.carNumber">{{scope.row.carNumber}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="user_name" label="姓名" min-width="120px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <i v-if="scope.row.sex=='1'" class="el-icon-male" ></i>
                        <i v-else-if="scope.row.sex=='2'" class="el-icon-female"></i>
                        <span style="white-space: nowrap;" :title="scope.row.userName">{{scope.row.userName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="tag_id" label="绑定标签" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.tagId">{{scope.row.tagId}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="binding_time" label="绑定时间" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bindingTimeStr">{{scope.row.bindingTimeStr}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="un_bound_time" label="解绑时间" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.unBoundTimeStr">{{scope.row.unBoundTimeStr}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注" min-width="160px">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.remarks">{{scope.row.remarks}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

          <!--查询工具条-->
          <el-col style="text-align: left;">
            <el-form :inline="true" :model="filters" ref="filters">
              <el-form-item prop="keywords">查询条件：</el-form-item>
              <el-form-item prop="startDate" class="item-cnt-lhfs-0">
                <template slot-scope="scope">
                  <el-date-picker
                      v-model="filters.startDate"
                      type="datetime"
                      clearable
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择开始时间">
                  </el-date-picker>
                </template>
              </el-form-item>
              <el-form-item prop="endDate" class="item-cnt-lhfs-0">
                <template slot-scope="scope">
                  <el-date-picker
                      v-model="filters.endDate"
                      type="datetime"
                      clearable
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择结束时间">
                  </el-date-picker>
                </template>
              </el-form-item>
              <el-form-item prop="keywords">
                <el-input v-model="filters.keywords" placeholder="请输入车辆类型/车牌号/司机编号/司机姓名" clearable :style="{width: '400px'}">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="researchRecord"></i>
                </el-input>
              </el-form-item>
              <el-form-item v-if="false" style="position: absolute;top: 9px;right: 20px;margin: 0;z-index: 3;">
                <el-button icon="el-icon-download" type="primary" size="mini" trigger="click" @click="exportData">数据导出</el-button>
              </el-form-item>
            </el-form>
          </el-col>

            <!-- 导出数据 -->
            <el-table :data="exportDatas" id="out-table2" style="display: none;">
                <el-table-column prop="carType" label="车辆类型">
                    <template slot-scope="scope">
                        {{scope.row.carType}}
                    </template>
                </el-table-column>
                <el-table-column prop="carNumber" label="车牌号">
                    <template slot-scope="scope">
                        {{scope.row.carNumber}}
                    </template>
                </el-table-column>
                <el-table-column prop="idCard" label="司机编号">
                    <template slot-scope="scope">
                        {{scope.row.idCard}}
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="司机姓名">
                    <template slot-scope="scope">
                        {{scope.row.userName}}
                    </template>
                </el-table-column>
                <el-table-column prop="sex" label="性别">
                    <template slot-scope="scope">
                        {{scope.row.sex}}
                    </template>
                </el-table-column>
                <el-table-column prop="tagId" label="绑定标签">
                    <template slot-scope="scope">
                        {{scope.row.tagId}}
                    </template>
                </el-table-column>
                <el-table-column prop="bindingTimeStr" label="绑定时间">
                    <template slot-scope="scope">
                        {{scope.row.bindingTimeStr}}
                    </template>
                </el-table-column>
                <el-table-column prop="unBoundTimeStr" label="解绑时间">
                    <template slot-scope="scope">
                        {{scope.row.unBoundTimeStr}}
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注">
                    <template slot-scope="scope">
                        {{scope.row.remarks}}
                    </template>
                </el-table-column>
            </el-table>

        </section>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import ApiRecord from "@/request/api-record"
import GlobalFun from "@/global/global-function"

export default {
    /**
     * @Des 组件名
     * @Auth
     * @Date 2021/6/4
     */
    name: "CarBindingTable",
    /**
     * @Des 组件引用
     * @Auth
     * @Date 2021/6/4
     */
    components: {
        // 分页组件
        Pagination,
    },
    /**
     * @Des 数据定义
     * @Auth
     * @Date 2021/6/4
     */
    data() {
        return {
            /**
             * @Des 分页数据
             * @Auth
             * @Date 2021/6/4
             */
            pagination:{
                total: 0,
                startNum: 0,
                limit: 20,
                currentPage: 1
            },
            /**
             * @Des 查询数据
             * @Auth
             * @Date 2021/6/4
             */
            filters: {
                keywords: '',
                startDate: '',
                endDate: '',
                orderBy: {
                    'binding_time': 'desc'
                },
                sortOrders: [
                    "ascending",
                    "descending"
                ],
                sortable: 'custom'
            },
            // 记录信息集合
            record: [],
            // 导出的数据
            exportDatas: [],
            locked: false
        }
    },
    computed: {
    },
    /**
     * @Des 监听
     * @Auth
     * @Date 2021/6/4
     */
    watch: {
        /**
         * @Des 分页监听
         * @Auth
         * @Date 2021/6/4
         */
        pagination: {
            handler(newVal, oldVal){
                this.searchRecord();
            },
            immediate: true,
            deep:true,
        }
    },
    /**
     * @Des 初始化加载
     * @Auth
     * @Date 2021/6/4
     */
    mounted(){
        // 查询记录信息
        this.searchRecord();
    },
    created(){
    },
    /**
     * @Des 方法定义
     * @Auth
     * @Date 2021/6/4
     */
    methods: {

        /**
         * 重新搜索
         * */
        researchRecord(){
            this.pagination.total = 0;
            this.pagination.startNum = 0;
            this.pagination.currentPage = 1;
            this.searchRecord();
        },

        /**
         * @Des 查询绑定记录
         * @Auth
         * @Date 2021/6/4
         */
        searchRecord(){
            if((this.filters.startDate == '' && this.filters.endDate != '')
                || (this.filters.startDate != '' && this.filters.endDate == '')){
                this.filters.startDate = '';
                this.filters.endDate = '';
            }
            this.$request.postJsonRequest(ApiRecord.searchCarRecord,{
                keyword: this.filters.keywords,
                beginTime: this.filters.startDate,
                endTime: this.filters.endDate,
                orderBy: this.filters.orderBy,
                projectId: this.$store.state.currentProjectId,
                total: this.pagination.total,
                startNum: this.pagination.startNum,
                limit: this.pagination.limit
            }).then(result => {
                // console.log(result)
                this.pagination.total = result.total;
                if(this.pagination.total > 0){
                    result.rows.forEach((row, index) => {
                        row.bindingTimeStr = row.bindingTime?this.$moment(row.bindingTime).format('YYYY-MM-DD HH:mm:ss'):'';
                        row.unBoundTimeStr = row.unBoundTime?this.$moment(row.unBoundTime).format('YYYY-MM-DD HH:mm:ss'):'';
                    })
                }
                this.record = result.rows;
            }).catch(error => {
                console.error('查询车辆列表异常', ApiRecord.searchCarRecord, error);
            })
        },

        /**
         * 导出数据
         * */
        exportData(){
            if(this.locked) return false;
            this.locked = true;
            if((this.filters.startDate == '' && this.filters.endDate != '')
                || (this.filters.startDate != '' && this.filters.endDate == '')){
                this.filters.startDate = '';
                this.filters.endDate = '';
            }
            this.$request.postJsonRequest(ApiRecord.exportCarRecord,{
                keyword: this.filters.keywords,
                beginTime: this.filters.startDate,
                endTime: this.filters.endDate,
                orderBy: this.filters.orderBy,
                projectId: this.$store.state.currentProjectId,
            }).then(result => {
                this.exportDatas = [];
                if(result.total > 0){
                    result.rows.forEach((row, index) => {
                        row.bindingTimeStr = row.bindingTime?this.$moment(row.bindingTime).format('YYYY-MM-DD HH:mm:ss'):'';
                        row.unBoundTimeStr = row.unBoundTime?this.$moment(row.unBoundTime).format('YYYY-MM-DD HH:mm:ss'):'';
                        this.exportDatas.push(row);
                    })
                }
                this.$nextTick( () => {
                    GlobalFun.exportExcel(document.querySelector("#out-table2"),'车辆绑定信息.xlsx');
                    this.locked = false;
                });
            }).catch(error => {
            	this.locked = false;
            	console.error('导出车辆列表异常', ApiRecord.exportCarRecord, error);
            })
        },

        /**
         * @Des 当前页数据改变
         * @Auth
         * @Date 2021/6/4
         */
        handleCurrentChangeSub(val){
            this.pagination.currentPage = val;
            this.pagination.startNum = this.pagination.limit * (val-1);
        },
        /**
         * @Des 页长度改变
         * @Auth
         * @Date 2021/6/4
         */
        handleSizeChangeSub(val){
            this.pagination.limit = val;
            this.pagination.currentPage = 1;
            this.pagination.startNum = 0;
        },
        /**
         * 改变排序
         * */
        changeSort(data){
            // console.log(data);
            let prop = data.prop;
            let order = data.order;
            if(order == null){
                order = this.filters.orderBy[prop];
            }else{
                order = order.replace("ending", "");
            }
            if(order == null){
                this.filters.orderBy["binding_time"] = "desc";
            }else{
                this.filters.orderBy = {};
                this.filters.orderBy[prop] = order;
            }
            this.researchRecord();
        },
    },
}
</script>
/* JS */

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Record/CarBindingTable.vue